import {useEffect, useRef, useState} from "react";

export const useCarousel = (itemsLength: number, gapWidth: number) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [shouldAutoplay, setShouldAutoplay] = useState(false);
  const carouselRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = carouselRef.current;
    if (!container) return;

    const track = container.children[0] as HTMLDivElement;
    const firstCard = track?.children[0] as HTMLDivElement;
    if (!track || !firstCard) return;

    const totalWidth =
      firstCard.offsetWidth * itemsLength + (itemsLength - 1) * gapWidth;
    const containerWidth = container.offsetWidth;

    const overflow = totalWidth > containerWidth;
    setShouldAutoplay(overflow);

    let interval: number | undefined;
    if (overflow) {
      interval = window.setInterval(() => {
        setActiveIndex((prev) => (prev + 1) % itemsLength);
        container.scrollTo({
          left: (firstCard.getBoundingClientRect().width + 16) * activeIndex,
          behavior: "smooth",
        });
      }, 4000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [activeIndex]);

  return {carouselRef, shouldAutoplay};
};
